import React from 'react';
import { useNavigation } from '../context/NavigationContext';
import { Footer } from '../components/Footer';
export function TermsPage() {
  const {
    navigate
  } = useNavigation();
  return <div className="min-h-screen bg-cream font-sans selection:bg-forest/20 flex flex-col" data-id="element-261">
      <div className="flex-grow max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-262">
        <button onClick={() => navigate('home')} className="text-forest font-medium mb-8 hover:underline flex items-center gap-2" data-id="element-263">
          ← Volver al inicio
        </button>

        <h1 className="text-3xl md:text-4xl font-serif text-charcoal mb-8" data-id="element-264">
          Términos y Condiciones
        </h1>

        <div className="prose prose-lg text-charcoal/80 space-y-6" data-id="element-265">
          <p data-id="element-266">Última actualización: {new Date().toLocaleDateString()}</p>

          <h2 className="text-xl font-bold text-charcoal mt-8 mb-4" data-id="element-267">
            1. Uso del Producto
          </h2>
          <p data-id="element-268">
            "El Mapa de Pago en 10 Min" es un producto digital para uso personal
            exclusivamente. Al comprarlo, adquieres una licencia individual. No
            está permitido compartir, revender, distribuir o reproducir el
            contenido del PDF ni sus materiales complementarios.
          </p>

          <h2 className="text-xl font-bold text-charcoal mt-8 mb-4" data-id="element-269">
            2. Política de Reembolso
          </h2>
          <p data-id="element-270">
            Debido a la naturaleza digital del producto (descarga inmediata),
            todas las ventas son finales. No ofrecemos reembolsos una vez que el
            archivo ha sido enviado o descargado, salvo que exista un defecto
            técnico comprobable con el archivo.
          </p>

          <h2 className="text-xl font-bold text-charcoal mt-8 mb-4" data-id="element-271">
            3. Propiedad Intelectual
          </h2>
          <p data-id="element-272">
            Todo el contenido, diseño, textos y gráficos incluidos en el
            producto son propiedad intelectual de "El Mapa de Pago en 10 Min" y
            están protegidos por las leyes de derechos de autor.
          </p>

          <h2 className="text-xl font-bold text-charcoal mt-8 mb-4" data-id="element-273">
            4. Descargo de Responsabilidad
          </h2>
          <p data-id="element-274">
            Este producto es una herramienta educativa y organizativa. No
            constituye asesoramiento financiero, legal o contable profesional.
            Los resultados pueden variar y dependen de la situación financiera
            individual de cada usuario. No garantizamos resultados específicos
            ni la eliminación de deudas.
          </p>
        </div>
      </div>
      <Footer data-id="element-275" />
    </div>;
}